<template>
  <router-view/>
  <ShowToast />
  <DynamicDialog />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'App',
  mounted() {
    this.axios.get('/sanctum/csrf-cookie').then(() => {
      console.log('sanctum/csrf-cookie ok')
    }).catch(() => {
      window.location.reload()
      // this.$toast.add({
      //   severity: 'error',
      //   summary: 'Probleme de connexion',
      //   detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
      //   life: 5000
      // });
    });
  },
})
</script>